export const state = {
  list: [],
  pagination: null
}
